/**
 * 环境变量验证工具
 * 确保生产环境必须配置正确的域名和地址
 */
var EnvValidator = /** @class */ (function () {
    function EnvValidator() {
    }
    /**
     * 验证环境变量
     * @param environment 环境类型
     * @param isProduction 是否为生产环境
     */
    EnvValidator.validate = function (_environment, isProduction) {
        if (_environment === void 0) { _environment = 'development'; }
        if (isProduction === void 0) { isProduction = false; }
        var errors = [];
        var warnings = [];
        this.rules.forEach(function (rule) {
            var value = process.env[rule.key];
            // 检查是否必需
            if (rule.required && (!value || value.trim() === '')) {
                if (isProduction) {
                    errors.push("\uD83D\uDEA8 ".concat(rule.key, " \u662F\u5FC5\u9700\u7684\uFF0C\u4F46\u672A\u914D\u7F6E"));
                }
                else {
                    warnings.push("\u26A0\uFE0F ".concat(rule.key, " \u672A\u914D\u7F6E\uFF0C\u5EFA\u8BAE\u8BBE\u7F6E\u73AF\u5883\u53D8\u91CF"));
                }
                return;
            }
            // 如果有值，进行验证
            if (value && rule.validator) {
                if (!rule.validator(value)) {
                    var errorMsg = rule.errorMessage || "".concat(rule.key, " \u9A8C\u8BC1\u5931\u8D25");
                    if (isProduction) {
                        errors.push("\uD83D\uDEA8 ".concat(errorMsg));
                    }
                    else {
                        warnings.push("\u26A0\uFE0F ".concat(errorMsg));
                    }
                }
            }
        });
        // 输出警告（开发环境）
        if (!isProduction && warnings.length > 0) {
            console.warn('环境变量配置警告：');
            warnings.forEach(function (warning) { return console.warn(warning); });
        }
        // 抛出错误（生产环境）
        if (isProduction && errors.length > 0) {
            console.error('生产环境配置错误：');
            errors.forEach(function (error) { return console.error(error); });
            throw new Error("\u751F\u4EA7\u73AF\u5883\u914D\u7F6E\u9A8C\u8BC1\u5931\u8D25\uFF1A\n".concat(errors.join('\n')));
        }
        // 成功验证
        if (isProduction) {
            console.log('✅ 生产环境配置验证通过');
        }
    };
    /**
     * 获取环境变量或抛出错误
     * @param key 环境变量键
     * @param fallback 默认值（仅开发环境）
     */
    EnvValidator.getRequiredEnv = function (key, fallback) {
        var value = process.env[key];
        var isProduction = process.env.NODE_ENV === 'production';
        if (!value || value.trim() === '') {
            if (isProduction) {
                throw new Error("\uD83D\uDEA8 \u751F\u4EA7\u73AF\u5883\u5FC5\u987B\u914D\u7F6E ".concat(key, " \u73AF\u5883\u53D8\u91CF"));
            }
            else {
                if (fallback) {
                    console.warn("\u26A0\uFE0F ".concat(key, " \u672A\u914D\u7F6E\uFF0C\u4F7F\u7528\u9ED8\u8BA4\u503C: ").concat(fallback));
                    return fallback;
                }
                else {
                    throw new Error("\uD83D\uDEA8 ".concat(key, " \u73AF\u5883\u53D8\u91CF\u672A\u914D\u7F6E"));
                }
            }
        }
        return value;
    };
    /**
     * 验证 URL 是否有效且不是 localhost
     * @param url URL 字符串
     * @param allowLocalhost 是否允许 localhost（默认 false）
     */
    EnvValidator.validateUrl = function (url, allowLocalhost) {
        if (allowLocalhost === void 0) { allowLocalhost = false; }
        try {
            var urlObj = new URL(url);
            if (!allowLocalhost) {
                var isLocalhost = urlObj.hostname === 'localhost' ||
                    urlObj.hostname === '127.0.0.1' ||
                    urlObj.hostname.startsWith('192.168.') ||
                    urlObj.hostname.startsWith('10.') ||
                    urlObj.hostname.startsWith('172.');
                if (isLocalhost && process.env.NODE_ENV === 'production') {
                    return false;
                }
            }
            return true;
        }
        catch (_a) {
            return false;
        }
    };
    /**
     * 获取所有配置的环境变量摘要
     */
    EnvValidator.getConfigSummary = function () {
        var summary = {};
        this.rules.forEach(function (rule) {
            var value = process.env[rule.key];
            if (value) {
                // 隐藏敏感信息
                if (rule.key.includes('SECRET') || rule.key.includes('PASSWORD') || rule.key.includes('KEY')) {
                    summary[rule.key] = '***';
                }
                else {
                    summary[rule.key] = value;
                }
            }
        });
        return summary;
    };
    EnvValidator.rules = [
        // 前端环境变量验证
        {
            key: 'REACT_APP_API_BASE_URL',
            required: true,
            validator: function (value) { return !value.includes('localhost'); },
            errorMessage: '生产环境不能使用 localhost，请配置有效域名'
        },
        {
            key: 'REACT_APP_MSLOGIN_URL',
            required: true,
            validator: function (value) { return !value.includes('localhost'); },
            errorMessage: '生产环境不能使用 localhost，请配置有效域名'
        },
        // 后端环境变量验证
        {
            key: 'CORS_ORIGIN',
            required: true,
            validator: function (value) { return value.includes('homaxs.com'); },
            errorMessage: '生产环境 CORS_ORIGIN 必须包含 homaxs.com 域名'
        },
        {
            key: 'MSLOGIN_API_URL',
            required: true,
            validator: function (value) { return !value.includes('localhost'); },
            errorMessage: '生产环境不能使用 localhost，请配置有效域名'
        },
        {
            key: 'REDIS_HOST',
            required: true,
            validator: function (value) { return !value.includes('localhost') && !value.includes('127.0.0.1'); },
            errorMessage: '生产环境不能使用 localhost 或 127.0.0.1，请配置 Redis 服务器地址'
        },
        {
            key: 'HOSTNAME',
            required: true,
            validator: function (value) { return value.length > 0; },
            errorMessage: '生产环境必须配置 HOSTNAME'
        }
    ];
    return EnvValidator;
}());
export { EnvValidator };
// 自动验证（如果环境变量启用）
if (process.env.ENABLE_ENV_VALIDATION === 'true') {
    var isProduction = process.env.NODE_ENV === 'production';
    try {
        EnvValidator.validate(process.env.NODE_ENV, isProduction);
    }
    catch (error) {
        console.error('环境变量验证失败:', error);
        if (isProduction) {
            process.exit(1); // 生产环境验证失败则退出
        }
    }
}
